module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Sub_Script.3c732df4.svg";